import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { HELPDESK } from '../../routes/routes';

import { Content, ContentTitle, TableContent } from './HelpDeskStyled';
import { Category } from './helpDesk.types';

interface TableContentRootPropsType {
  categories: Category[];
  id: number;
}

export const TableContentRoot = ({
  categories,
  id
}: TableContentRootPropsType) => {
  const { t } = useTranslation('helpdesk');

  return (
    <TableContent>
      <ContentTitle>{t('table_of_contents')}</ContentTitle>
      {categories?.map((content, index) => (
        <Link to={`${HELPDESK}/${content.id}`} key={index}>
          <Content selected={id == content.id}>
            {`${index + 1}. ${content.name}`}
          </Content>
        </Link>
      ))}
    </TableContent>
  );
};
